import React from 'react'
import { Typography, Button } from '@material-ui/core'
import { useSherwinTrialOverDashboard } from '../useSherwinTrialOverDashboard'
import { useUser } from '@paintscout/ui'
import { useSherwinTrialOverDashboardDesktopLayoutStyles } from './useSherwinTrialOverDashboardDesktopLayoutStyles'
import SherwinCouponCard from '../SherwinCouponCard'

export default function SherwinTrialOverDashboardDesktop() {
  const classes = useSherwinTrialOverDashboardDesktopLayoutStyles()
  const { isAdmin, handleSelectPlan } = useSherwinTrialOverDashboard()
  const { isChurned } = useUser()

  return (
    <div className={classes.root}>
      <div className={classes.whiteBackground} />
      <div className={classes.leftSection}>
        <div className={classes.leftSectionContent}>
          <Typography className={classes.heading}>
            <span className={classes.headingFirstLine}>
              <span className={classes.headingHighlight}>Your PaintScout trial is over,</span>
            </span>
            <span className={classes.headingSecondLine}>but it doesn't have to end here.</span>
          </Typography>
          <Typography className={classes.description}>
            Sign up for a subscription to get your $100 Sherwin-Williams coupon.
          </Typography>
          {isAdmin && !isChurned && (
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSelectPlan}
              className={classes.button}
            >
              Select Plan
            </Button>
          )}
        </div>
      </div>
      <div className={classes.rightSection}>
        <SherwinCouponCard />
      </div>
    </div>
  )
}
